<template>
	<div class="blockItem">
		<div class="blockBody">
			<div class="blockTitle">
				<div class="blockTitleL">德育评价数据</div>
				<!-- <div class="blockTitleR">今日生病学生数：132</div> -->
			</div>
			<div class="blockContent">
				<div class="dataV3">
					<div class="content content1">
						<div class="title1">今日评价分数</div>
						<div class="count1">{{$utils.outputdollars(56214)}}</div>
					</div>
					<div class="content">
						<div class="title2">同比昨日</div>
						<i class="iconfont icon-triangle add"></i>
						<countTo class="count2 add" :startVal='0' :endVal='56214' :duration='2000'></countTo>
					</div>
				</div>
				<div class="dataV3">
					<div class="content content1">
						<div class="title1">今日评价学生数</div>
						<div class="count1">{{$utils.outputdollars(78214)}}</div>
					</div>
					<div class="content">
						<div class="title2">同比昨日</div>
						<i class="iconfont icon-triangle cut"></i>
						<countTo class="count2 cut" :startVal='0' :endVal='56214' :duration='2000'></countTo>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import countTo from 'vue-count-to'
	
	export default {
		components: {
			countTo
		},
		data() {
			return {
				
			}
		},
		mounted() {
			
		},
		methods: {
			
		},
	}
</script>

<style lang="less" scoped>
	.dataV3 {
		display: flex;
		align-items: center;
		height: 45%;
		padding: 0 24px;
		.content {
			&.content1 {
				width: 60%;
			}
			display: flex;
			align-items: center;
			.title1 {
				font-size: 20px;
				margin-right: 12px;
			}
			.title2 {
				font-size: 17px;
				margin-right: 12px;
			}
			.count1 {
				font-size: 28px;
			}
			.count2 {
				font-size: 24px;
			}
			i {
				display: inline-block;
				font-size: 26px;
			}
			.add {
				color: #f45d5d;
			}
			.cut {
				color: #4ad569;
				&.icon-triangle {
					transform: rotate(180deg);
				}
			}
		}
	}
</style>
